import { useMemo } from "react";
import { useClaims } from "./ClaimsProvider";

/**
 * Returns the user's currently selected OrgUnitId from claims.
 */
export function useOrgUnitIdCurrent(): number | null {
  const { getClaimValue } = useClaims();

  return useMemo(() => {
    const raw = getClaimValue("orgUnitIdCurrent");

    if (!raw) return null;

    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }, [getClaimValue]);
}
